@if (tenantLogoSrc) {
  <img
    class="tenant-logo"
    [src]="tenantLogoSrc"
    width="200"
    height="80"
  />
} @else {
  <app-skeleton
    height="80px"
    width="80px"
  ></app-skeleton>
}
